// The comparison pages, as one tab strip.
//
// Version Cohorts and A/B Tests ask the same question across different
// boundaries — "did the last release move the numbers?" and "did this
// experiment move them?" — over the same population and the same step
// definitions. They share a grant (`version_cohorts`) for that reason, and they
// share this strip so a reader who found one can find the other. Without it the
// A/B page would be reachable only by typing its URL, since the sidebar lists
// AREAS and these two are one area. The shortlist-timeframe readout (Monday
// 3204302464) is the third: the same aggregate-only contract, across the
// boundary the BUYER picks (how long Mira collects proposals).

import { Link } from "@tanstack/react-router";

import "./cohort-tabs.css";

type Props = {
  /** Which tab is the page rendering it. */
  active: "release" | "ab" | "timeframe";
};

export function CohortTabs({ active }: Props) {
  return (
    <nav className="cohort-tabs" aria-label="Comparison">
      <Link
        to="/version-cohorts"
        className={"cohort-tabs__tab" + (active === "release" ? " cohort-tabs__tab--on" : "")}
        aria-current={active === "release" ? "page" : undefined}
      >
        By release
      </Link>
      {/* The experiment readout moved onto each experiment's own page under
          /experiments (its old /ab-tests path redirects there), so this tab
          points at the register. */}
      <Link
        to="/experiments"
        className={"cohort-tabs__tab" + (active === "ab" ? " cohort-tabs__tab--on" : "")}
        aria-current={active === "ab" ? "page" : undefined}
      >
        By experiment
      </Link>
      <Link
        to="/shortlist-timeframe"
        className={"cohort-tabs__tab" + (active === "timeframe" ? " cohort-tabs__tab--on" : "")}
        aria-current={active === "timeframe" ? "page" : undefined}
      >
        By timeframe
      </Link>
    </nav>
  );
}
